module.exports = __webpack_public_path__ + "static/media/community-gardens-gallery-17.76549c33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/community-gardens-gallery-17.jpg
// module id = 689
// module chunks = 13